import { useEffect, useState } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';

/**
 * The app's tooltip for locked fields. Any element with `data-yz-hint="…"`
 * shows that text in the app's tooltip (styles/alerts.css) with a small lock
 * while hovered — including disabled inputs, which can't use OverlayTrigger.
 * Mounted once (App.jsx); useLockHints fills the attribute in on its own.
 */
export default function HintTooltip() {
  const [tip, setTip] = useState(null);

  useEffect(() => {
    const over = (e) => {
      const el = e.target instanceof Element ? e.target.closest('[data-yz-hint]') : null;
      setTip((t) => (el ? (t?.el === el ? t : { el, text: el.getAttribute('data-yz-hint') }) : null));
    };
    // Leaving the window, scrolling or clicking away hides it.
    const out = (e) => {
      if (!e.relatedTarget) setTip(null);
    };
    const hide = () => setTip(null);
    document.addEventListener('mouseover', over);
    document.addEventListener('mouseout', out);
    window.addEventListener('scroll', hide, true);
    document.addEventListener('mousedown', hide);
    return () => {
      document.removeEventListener('mouseover', over);
      document.removeEventListener('mouseout', out);
      window.removeEventListener('scroll', hide, true);
      document.removeEventListener('mousedown', hide);
    };
  }, []);

  return (
    <Overlay target={tip?.el} show={!!tip?.text && !!tip?.el?.isConnected} placement="top">
      {(props) => (
        <Tooltip id="yz-lock-hint" {...props}>
          <i className="ph ph-lock-simple" style={{ marginRight: 7, verticalAlign: -1 }} aria-hidden="true" />
          {tip?.text}
        </Tooltip>
      )}
    </Overlay>
  );
}
